// declare const qz: any;
import qz from "qz-tray";
import { AppDispatch } from "../../../store/store";
import { setClientVersion } from "../../../store/slices/qztray/qzTrayClientSlice";

export const fetchVersionLogic = async (dispatch: AppDispatch) => {
  if (!qz.websocket.isActive()) {
    // console.warn("⚠️ No se puede obtener versión: WebSocket no está activo.");
    dispatch(setClientVersion(null));
    return null;
  }

  try {
    const v = await qz.api.getVersion();
    // console.log("🧩 Versión detectada manualmente:", v);
    dispatch(setClientVersion(v ?? null));
    return v ?? null;
  } catch (err: any) {
    console.error("❌ Error obteniendo versión QZ Tray:", err?.message || err);
    dispatch(setClientVersion(null));
    return null;
  }
};
